{
  "menu": {
    "about": "Tentang Kami",
    "facilities": "Fasilitas",
    "villas": "Vila & Harga",
    "allRooms": "Semua Kamar",
    "experiences": "Aktivitas",
    "gallery": "Galeri",
    "news": "Berita",
    "contact": "Kontak"
  },
  "contact": {
    "hero": {
      "subtitle": "Hubungi Kami",
      "title": "Kontak",
      "desc": "Kami di sini untuk membantu Anda. Hubungi kami untuk pertanyaan, reservasi, atau permintaan khusus.",
      "scroll": "Hubungi Kami"
    },
    "info": {
      "title": "Informasi",
      "desc": "Punya pertanyaan atau butuh bantuan? Tim kami selalu siap membantu Anda merencanakan masa inap yang sempurna di Sidemen.",
      "address": "Jl. Raya Sidemen, Sinduwati, Sidemen, Kabupaten Karangasem, Bali 80864"
    },
    "form": {
      "title": "Kirimkan Pesan",
      "name": "Nama Anda",
      "email": "Email Anda",
      "subject": "Subjek",
      "message": "Pesan",
      "btnSend": "Kirim Pesan",
      "btnSending": "Mengirim...",
      "success": "Terima kasih! Pesan Anda telah berhasil dikirim.",
      "error": "Ups! Ada yang salah. Silakan coba lagi nanti."
    }
  },
  "faq": {
    "q1": {
      "question": "Jam berapa waktu check-in dan check-out?",
      "answer": "Waktu check-in adalah pukul 14:00, dan check-out pukul 12:00 siang. Check-in lebih awal atau check-out lebih lambat tergantung pada ketersediaan dan mungkin dikenakan biaya tambahan."
    },
    "q2": {
      "question": "Apakah sarapan sudah termasuk dalam harga kamar?",
      "answer": "Ya, sarapan harian gratis sudah termasuk untuk semua pemesanan vila kami."
    },
    "q3": {
      "question": "Apakah Anda menyediakan layanan antar-jemput bandara?",
      "answer": "Ya, kami menawarkan layanan antar-jemput bandara dengan biaya tambahan. Harap hubungi kami sebelumnya untuk mengatur penjemputan Anda."
    },
    "q4": {
      "question": "Apakah Patal Kikian ramah keluarga?",
      "answer": "Meskipun kami menyambut tamu dari segala usia, properti kami dirancang sebagai tempat peristirahatan yang tenang. Orang tua harus mengawasi anak-anak setiap saat, terutama di dekat area kolam renang."
    },
    "q5": {
      "question": "Apakah Anda melayani pantangan makanan?",
      "answer": "Tentu saja. Restoran kami dapat melayani berbagai kebutuhan diet termasuk vegetarian, vegan, dan bebas gluten. Harap beri tahu kami kebutuhan Anda sebelum kedatangan."
    },
    "q6": {
      "question": "Apakah ada Wi-Fi di vila?",
      "answer": "Ya, Wi-Fi berkecepatan tinggi gratis tersedia di seluruh area properti, termasuk di semua kamar dan area umum."
    },
    "subtitle": "Informasi",
    "title": "Pertanyaan yang Sering Diajukan",
    "stillHaveQuestions": "Masih punya pertanyaan?",
    "btnContact": "Hubungi Kami"
  },
  "terms": {
    "usage": {
      "title": "Penggunaan Situs Web",
      "p1": "Selamat datang di situs web kami. Jika Anda terus menelusuri dan menggunakan situs web ini, Anda setuju untuk mematuhi dan terikat oleh syarat dan ketentuan penggunaan berikut, yang bersama dengan kebijakan privasi kami mengatur hubungan Patal Kikian Villas dengan Anda sehubungan dengan situs web ini.",
      "p2": "Jika Anda tidak setuju dengan bagian mana pun dari syarat dan ketentuan ini, mohon jangan gunakan situs web kami. Istilah ‘Patal Kikian Villas’ atau ‘kami’ merujuk pada pemilik situs web. Istilah ‘Anda’ merujuk pada pengguna atau pelihat situs web kami.",
      "p3": "Isi halaman-halaman di situs web ini hanya untuk informasi umum dan penggunaan Anda. Hal ini dapat berubah tanpa pemberitahuan. Penggunaan Anda atas informasi atau materi apa pun di situs web ini sepenuhnya merupakan risiko Anda sendiri, yang mana kami tidak bertanggung jawab atas hal tersebut. Merupakan tanggung jawab Anda sendiri untuk memastikan bahwa setiap produk, layanan, atau informasi yang tersedia melalui situs web ini memenuhi persyaratan spesifik Anda."
    },
    "booking": {
      "title": "Kondisi Pemesanan",
      "p1_bold": "Kontrak Anda dengan Patal Kikian Villas:",
      "p1": "Kondisi Pemesanan ini, bersama dengan kebijakan privasi kami dan di mana liburan Anda dipesan melalui situs web kami, agen perjalanan online, atau sumber pemesanan lainnya, membentuk dasar kontrak Anda dengan Patal Kikian Villas. Dengan melakukan pemesanan, orang pertama yang namanya tertera pada pemesanan setuju atas nama semua orang yang dirinci pada pemesanan bahwa ia telah membaca syarat dan ketentuan ini dan memiliki wewenang untuk serta setuju untuk terikat dengannya.",
      "p2_bold": "Membayar pemesanan Anda:",
      "p2": "Pada saat pemesanan, Anda akan diminta untuk memberikan rincian kartu kredit yang valid atau membayar deposit melalui transfer bank untuk masa inap satu malam guna mengonfirmasi pemesanan. Ketidakhadiran (no-show) akan didebit dari rincian kartu kredit yang tersimpan pada sistem.",
      "p3_bold": "Akurasi:",
      "p3": "Kami berusaha untuk memastikan bahwa semua informasi dan harga di situs web kami akurat; namun demikian, sesekali perubahan dan kesalahan dapat terjadi, dan kami berhak untuk memperbaiki harga dan rincian lainnya dalam keadaan tersebut."
    },
    "cancellation": {
      "title": "Kebijakan Pembatalan",
      "p1_bold": "Harga Standar:",
      "p1": "Pembatalan yang dilakukan dalam 14 hari sebelum kedatangan akan dikenakan biaya pembatalan sebesar satu malam. Pembatalan yang dilakukan dalam 7 hari sebelum kedatangan, atau jika Anda tidak datang (no-show), akan dikenakan biaya pembatalan sebesar 100% dari total nilai pemesanan.",
      "p2_bold": "Harga Non-Refundable:",
      "p2": "Pemesanan yang dilakukan berdasarkan harga tidak dapat dikembalikan (non-refundable) tidak dapat dibatalkan atau diubah tanpa dikenakan biaya 100%."
    },
    "copyright": {
      "title": "Pemberitahuan Hak Cipta",
      "p1": "Situs web ini dan isinya adalah hak cipta dari Patal Kikian Villas. Hak cipta dilindungi undang-undang. Segala bentuk redistribusi atau reproduksi sebagian atau seluruh isi dalam bentuk apa pun dilarang selain mengunduh ke hard disk lokal untuk penggunaan pribadi dan non-komersial Anda sendiri."
    },
    "subtitle": "Legal",
    "title": "Syarat dan Ketentuan"
  },
  "privacy": {
    "policy": {
      "title": "Kebijakan Privasi",
      "p1": "Kami memahami bahwa memberikan informasi pribadi dan melakukan pembelian secara online melibatkan banyak kepercayaan di pihak Anda; kami menanggapi kepercayaan ini dengan sangat serius. Kebijakan privasi ini menetapkan bagaimana Patal Kikian Villas menggunakan dan melindungi setiap informasi yang Anda berikan saat Anda menggunakan situs web ini.",
      "p2": "Patal Kikian Villas berkomitmen untuk memastikan bahwa privasi Anda terlindungi. Apabila kami meminta Anda untuk memberikan informasi tertentu yang dengannya Anda dapat diidentifikasi saat menggunakan situs web ini, maka Anda dapat yakin bahwa informasi tersebut hanya akan digunakan sesuai dengan pernyataan privasi ini.",
      "p3": "Kami dapat mengubah kebijakan ini dari waktu ke waktu dengan memperbarui halaman ini. Anda harus memeriksa halaman ini dari waktu ke waktu untuk memastikan bahwa Anda berkenan dengan perubahan apa pun."
    },
    "collect": {
      "title": "Apa yang Kami Kumpulkan",
      "p1": "Kami dapat mengumpulkan informasi berikut:",
      "l1": "Nama dan informasi kontak termasuk alamat email",
      "l2": "Informasi demografis seperti kode pos, preferensi, dan minat",
      "l3": "Informasi lain yang relevan dengan survei pelanggan dan/atau penawaran",
      "l4": "Alamat IP komputer Anda"
    },
    "usage": {
      "title": "Apa yang Kami Lakukan dengan Informasi yang Dikumpulkan",
      "p1": "Kami memerlukan informasi ini untuk memahami kebutuhan Anda dan memberi Anda layanan yang lebih baik, dan khususnya untuk alasan-alasan berikut:",
      "l1": "Pencatatan internal.",
      "l2": "Kami dapat menggunakan informasi tersebut untuk meningkatkan produk dan layanan kami.",
      "l3": "Kami secara berkala dapat mengirim email promosi tentang produk baru, penawaran khusus, atau informasi lain yang menurut kami menarik bagi Anda menggunakan alamat email yang Anda berikan.",
      "l4": "Kami dapat menggunakan informasi tersebut untuk menyesuaikan situs web berdasarkan minat Anda.",
      "p2": "Anda dapat memilih keluar dari layanan ini atau memperbaiki ketidakakuratan apa pun dalam informasi yang kami simpan tentang Anda kapan saja dengan menghubungi kami melalui email di info@patalkikianbali.com."
    },
    "security": {
      "title": "Keamanan & Informasi Keuangan",
      "p1": "Kami berkomitmen untuk memastikan bahwa informasi Anda aman. Untuk mencegah akses atau pengungkapan yang tidak sah, kami telah menempatkan prosedur fisik, elektronik, dan manajerial yang sesuai untuk menjaga dan mengamankan informasi yang kami kumpulkan secara online.",
      "p2_bold": "Informasi Keuangan:",
      "p2": "Kami saat ini tidak menyimpan atau bermaksud menyimpan informasi keuangan apa pun seperti nomor kartu kredit atau debit di server lokal kami. Pembayaran diproses melalui portal pihak ketiga yang aman."
    },
    "cookies": {
      "title": "Bagaimana Kami Menggunakan Cookies",
      "p1": "Cookie adalah file kecil yang meminta izin untuk ditempatkan pada hard drive komputer Anda. Setelah Anda setuju, file ditambahkan dan cookie membantu menganalisis lalu lintas web atau memberi tahu Anda saat Anda mengunjungi situs tertentu. Cookies memungkinkan aplikasi web untuk merespons Anda sebagai individu. Anda dapat memilih untuk menerima atau menolak cookies melalui pengaturan peramban Anda."
    },
    "subtitle": "Legal",
    "title": "Kebijakan Privasi"
  },
  "footer": {
    "explore": "Eksplor",
    "information": "Informasi",
    "desc": "Rasakan kehidupan Sidemen yang tenang. Nikmati pemandangan Gunung Agung yang spektakuler, vila mewah, dan keramahtamahan yang sempurna untuk wisatawan yang mencari relaksasi di Bali.",
    "translate": "Terjemahkan",
    "quickLinks": "Tautan Cepat",
    "support": "Dukungan",
    "contactTitle": "Kontak",
    "contact": "Kontak",
    "faq": "FAQ",
    "terms": "Syarat & Ketentuan",
    "privacy": "Kebijakan Privasi",
    "whatsappUs": "WhatsApp Kami",
    "allRightsReserved": "Hak cipta dilindungi undang-undang.",
    "newsJournal": "Berita & Jurnal"
  },
  "news": {
    "journal": "Jurnal",
    "latest": "Berita & Cerita Terbaru",
    "subtitle": "Tetap ikuti perkembangan berita, cerita, dan acara terbaru di sekitar Patal Kikian dan Sidemen.",
    "readNews": "Baca Berita",
    "allArticles": "Semua Artikel",
    "noArticles": "Tidak ada artikel di kategori ini.",
    "page": "Halaman",
    "of": "dari"
  },
  "newsSearch": {
    "searchBreadcrumb": "Cari",
    "searchResults": "Hasil Pencarian",
    "searchArticles": "Cari Artikel",
    "resultsFound": "{{count}} hasil ditemukan",
    "forQuery": " untuk \"{{query}}\"",
    "placeholder": "Cari artikel...",
    "searchBtn": "Cari",
    "noResults": "Tidak ada artikel yang cocok dengan \"{{query}}\".",
    "enterKeyword": "Masukkan kata kunci untuk mencari artikel.",
    "backToNews": "Kembali ke Berita"
  },
  "newsCategory": {
    "category": "Kategori",
    "articlesInCat": "artikel di kategori ini",
    "noArticles": "Tidak ada artikel di kategori ini.",
    "backToNews": "Kembali ke Berita"
  },
  "newsDetail": {
    "search": "Pencarian",
    "searchPlaceholder": "Cari artikel...",
    "go": "Cari",
    "categories": "Kategori",
    "popularPosts": "Artikel Populer",
    "tags": "Tag",
    "exclusiveStay": "Penginapan Eksklusif",
    "promoDesc": "Rasakan Kemewahan Premium di Sidemen",
    "bookStay": "Pesan Penginapan Anda",
    "reserveStay": "Reservasi Penginapan Anda",
    "villaRecs": "Rekomendasi Vila",
    "recAccommodations": "Akomodasi yang Disarankan",
    "readArticle": "Baca Artikel",
    "bookNow": "Pesan Sekarang",
    "notFound": "Artikel Tidak Ditemukan",
    "notFoundDesc": "Artikel berita yang Anda cari tidak ada atau telah dipindahkan.",
    "backToNews": "Kembali ke Berita"
  },
  "luxuryCard": {
    "discover": "Temukan"
  },
  "blog": {
    "understanding-massage-and-facial-treatments": {
      "title": "Memahami Perawatan Pijat dan Wajah: Manfaat untuk Tubuh dan Pikiran",
      "excerpt": "Pelajari tentang perawatan pijat dan wajah, manfaat kesehatannya, dan mengapa keduanya penting untuk relaksasi dan perawatan diri."
    },
    "taste-of-bali-traditional-ingredients-and-iconic-dishes": {
      "title": "Cita Rasa Bali: Bahan Tradisional dan Hidangan Ikonis Bali",
      "excerpt": "Temukan bahan penting di balik masakan Bali, hidangan paling disukai di pulau ini, dan tempat untuk menikmati pengalaman bersantap yang tak terlupakan di Restoran Patal Kikian."
    },
    "sidemen-travel-guide-best-time-to-visit": {
      "title": "Panduan Wisata Sidemen: Waktu Terbaik Berkunjung dan Apa yang Harus Dikemas",
      "excerpt": "Rencanakan perjalanan Anda ke Sidemen dengan panduan lengkap kami, yang mencakup musim terbaik untuk berkunjung, saran cuaca, dan daftar perbekalan."
    },
    "wellness-retreat-in-bali": {
      "title": "Mengapa Sidemen Adalah Destinasi Sempurna untuk Liburan Kebugaran di Bali",
      "excerpt": "Jelajahi mengapa suasana tenang, udara bersih, dan warisan budaya Sidemen menjadikannya lokasi ideal untuk liburan kebugaran yang meremajakan."
    },
    "authors": {
      "Patal Kikian Villas Team": {
        "name": "Tim Patal Kikian Villas",
        "role": "Administrator",
        "bio": "Tim kami senang berbagi pengetahuan tentang keramahan Bali, tradisi kesehatan, budaya lokal, dan pengalaman tak terlupakan di Sidemen."
      }
    },
    "tags": {
      "Spa": "Spa",
      "Massage": "Pijat",
      "Facial": "Perawatan Wajah",
      "Wellness": "Kebugaran",
      "Relaxation": "Relaksasi",
      "Sidemen": "Sidemen",
      "Patal Kikian Spa": "Spa Patal Kikian",
      "Culinary": "Kuliner",
      "Balinese Food": "Makanan Bali",
      "Travel Guide": "Panduan Wisata",
      "Retreat": "Retret",
      "Nature": "Alam",
      "Yoga": "Yoga"
    }
  },
  "blogCategories": {
    "blog": {
      "name": "Blog"
    }
  },
  "rooms": {
    "private-pool-villa-mountain-view": {
      "title": "Vila Kolam Pribadi - Pemandangan Gunung",
      "description": "Rasakan kemewahan tropis minimalis terbaik di Bali. Perpaduan harmonis antara kemewahan kontemporer dan estetika tradisional. Cocok untuk tamu yang mencari pemandangan sawah Sidemen dan Gunung Agung langsung dari kolam renang pribadi tanpa batas.",
      "view": "Pemandangan Gunung & Sawah"
    },
    "suite-room-mountain-view": {
      "title": "Kamar Suite - Pemandangan Gunung",
      "description": "Beristirahatlah dalam kenyamanan kamar suite kami dengan balkon lebar. Dilengkapi perabotan kayu yang elegan dengan pemandangan menakjubkan ke hamparan hijau Sidemen dan Gunung Agung dari kenyamanan kamar.",
      "view": "Pemandangan Gunung"
    },
    "deluxe-bungalow-mountain-view": {
      "title": "Bungalow Deluxe - Pemandangan Gunung",
      "description": "Bungalow kayu bergaya Bali klasik dengan kenyamanan modern, teras menawan, dan dikelilingi oleh taman rimbun. Sebuah tempat persembunyian sempurna bagi pencinta alam.",
      "view": "Pemandangan Gunung"
    },
    "deluxe-room-garden-view-1": {
      "title": "Kamar Deluxe - Pemandangan Taman (Twin Bed)",
      "description": "Kamar mewah dan lapang dengan tempat tidur terpisah, menampilkan desain Bali kontemporer dengan jendela besar yang terbuka ke arah pemandangan taman tropis kami yang rimbun.",
      "view": "Pemandangan Taman"
    },
    "deluxe-room-garden-view": {
      "title": "Kamar Deluxe - Pemandangan Taman",
      "description": "Bersantailah dalam suasana asri taman tropis. Kamar Deluxe yang nyaman dan elegan ini menyediakan tempat yang tepat untuk melarikan diri dari hiruk-pikuk kota.",
      "view": "Pemandangan Taman"
    },
    "features": {
      "1 Bedroom": "1 Kamar Tidur",
      "Private Pool": "Kolam Pribadi",
      "Mountain View": "Pemandangan Gunung",
      "Bathtub": "Bak Mandi",
      "Garden View": "Pemandangan Taman",
      "Twin Bed": "Kasur Terpisah"
    },
    "amenities": {
      "King-sized beds": "Kasur King",
      "En-suite bathrooms": "Kamar Mandi Dalam",
      "Infinity pool": "Kolam Renang Infinity",
      "High-speed Wi-Fi": "Wi-Fi Kecepatan Tinggi",
      "Twin-sized beds": "Kasur Twin",
      "Private Balcony": "Balkon Pribadi",
      "Air Conditioning": "Pendingin Ruangan (AC)",
      "Daily Housekeeping": "Layanan Pembersihan Harian",
      "Smart TV": "Smart TV",
      "Mini Bar": "Mini Bar",
      "Coffee & Tea Maker": "Pembuat Kopi & Teh"
    },
    "inclusions": {
      "Daily breakfast for 2": "Sarapan harian untuk 2 orang",
      "Welcome drink": "Minuman selamat datang",
      "Daily bottled water": "Air minum kemasan harian",
      "Free Wi-Fi": "Wi-Fi gratis",
      "Access to main pool": "Akses ke kolam utama"
    }
  },
  "accommodation": {
    "detail": {
      "directBooking": "Pesan Langsung ke Kami",
      "bookingCom": "Pesan di Booking.com",
      "aboutRoom": "Tentang Kamar Ini",
      "roomSize": "Ukuran Kamar",
      "bedSize": "Ukuran Kasur",
      "view": "Pemandangan",
      "amenities": "Fasilitas Kamar",
      "inclusions": "Termasuk",
      "pleaseNote": "Harap Diperhatikan",
      "roomRules": "Aturan Kamar",
      "roomPolicy": "Kebijakan Kamar",
      "childrenPolicies": "Kebijakan Anak",
      "childrenPolicyDesc": "Anak dari segala usia diperbolehkan.",
      "babyCot": "Ranjang Bayi",
      "babyCotDesc": "Ranjang bayi tersedia berdasarkan permintaan.",
      "extraBed": "Kasur Tambahan",
      "extraBedDesc": "Kasur tambahan tersedia berdasarkan permintaan dengan biaya tambahan.",
      "noSmoking": "Dilarang merokok",
      "noPets": "Hewan peliharaan tidak diperbolehkan",
      "reserve": "Reservasi",
      "contactConcierge": "Hubungi resepsionis kami untuk permintaan khusus atau antar-jemput bandara.",
      "loading": "Memuat Detail Akomodasi...",
      "gallerySub": "GALERI KAMAR",
      "galleryTitle": "Lihat Lebih Dekat",
      "noImages": "Tidak ada gambar tersedia untuk akomodasi ini.",
      "signature": "Pilihan Mewah",
      "otherChoices": "Pilihan Lainnya",
      "otherRooms": "Jelajahi Kamar Lainnya"
    }
  },
  "restaurant": {
    "hero": {
      "subtitle": "Restoran Hutan Daun",
      "title": "Perjalanan Kuliner yang Menenangkan Jiwa",
      "desc": "Nikmati kreasi kuliner istimewa yang menyehatkan tubuh, ditemani pesona megah Gunung Agung dan lembah hijau Sidemen—sebuah suasana yang dirancang untuk menenangkan hati dan menyegarkan pikiran.",
      "btnScroll": "Lihat Menu"
    },
    "backToHome": "Kembali ke Beranda",
    "sidebar": {
      "categories": "Kategori"
    },
    "bestSeller": "Terlaris",
    "taxNote": "* Semua harga belum termasuk 11% pajak pemerintah dan 10% layanan",
    "legend": {
      "V": "V = Vegan",
      "VG": "VG = Vegetarian",
      "GF": "GF = Bebas Gluten",
      "DF": "DF = Bebas Produk Susu",
      "CN": "CN = Mengandung Kacang"
    },
    "categories": {
      "Appetizers": "Makanan Pembuka",
      "Soup": "Sup",
      "Main Course": "Hidangan Utama",
      "Main Course_subtitle": "Balinese & Nusantara",
      "Special Patal Kikian Balinese Menu": "Menu Spesial Patal Kikian Bali",
      "Asian": "Asia",
      "Western": "Barat",
      "Pasta": "Pasta",
      "Pizza": "Pizza",
      "Dessert": "Makanan Penutup",
      "Juice": "Jus",
      "Soft Drinks": "Minuman Ringan",
      "Refreshment": "Minuman Penyegar",
      "Smoothies": "Smoothie",
      "Milkshake": "Susu Kocok (Milkshake)",
      "Special Tea": "Teh Spesial",
      "Herbal": "Herbal",
      "Special Coffe": "Kopi Spesial",
      "Special Coffe_subtitle": "Hot Coffe",
      "Iced Coffe": "Kopi Es",
      "Additional Charge": "Biaya Tambahan",
      "Mocktail": "Mocktail",
      "Cocktail": "Cocktail"
    },
    "tags": {
      "VG": "VG",
      "DF": "DF",
      "Contains Pork": "Mengandung Babi",
      "GF": "GF",
      "V": "V",
      "Spicy": "Pedas",
      "Contains Nut": "Mengandung Kacang"
    },
    "items": {
      "Vegetable Spring Roll": {
        "name": "Lumpia Sayur",
        "description": "Lumpia sayur goreng disajikan dengan saus cabai manis"
      },
      "Bruschetta": {
        "name": "Bruschetta",
        "description": "Potongan roti baguette renyah, salsa tomat, bawang, kemangi, dan keju parmesan"
      },
      "Garlic Cheese Bread": {
        "name": "Roti Bawang Keju",
        "description": "Potongan roti baguette renyah dengan keju mozzarella"
      },
      "Chicken Caesar Salad": {
        "name": "Salad Caesar Ayam",
        "description": "Dada ayam panggang, daging babi (bacon) renyah, telur, selada romaine, irisan roti baguette renyah, keju parmesan, disajikan dengan saus caesar"
      },
      "Tuna Tartare": {
        "name": "Tartar Tuna",
        "description": "Irisan tuna segar dengan alpukat tumbuk dan salsa tomat, mayones buah naga"
      },
      "Salmon Tartare": {
        "name": "Tartar Salmon",
        "description": "Irisan salmon segar dengan alpukat tumbuk dan salsa tomat, mayones buah naga"
      },
      "Tuna Tataki": {
        "name": "Tuna Tataki",
        "description": "Loin tuna panggang wajan dengan biji wijen, mentimun, alpukat, disajikan dengan mayones buah naga, mayones bunga telang, dan salsa tomat"
      },
      "Green Patal Kikian Salad": {
        "name": "Salad Hijau Patal Kikian",
        "description": "Selada, campuran paprika, mentimun, bawang, tomat, jagung, alpukat, kubis merah, disajikan dengan saus vinaigrette"
      },
      "Prawn Avocado Salad": {
        "name": "Salad Udang Alpukat",
        "description": "Udang panggang, irisan alpukat, mentimun, selada, bawang, tomat, paprika, disajikan dengan saus koktail, mayones bunga telang"
      },
      "Onion Soup": {
        "name": "Sup Bawang",
        "description": "Sup bawang karamel disajikan dengan roti bawang keju"
      },
      "Tomato Corn Soup": {
        "name": "Sup Tomat Jagung",
        "description": "Sup tomat dan jagung krim disajikan dengan roti bawang keju"
      },
      "Sea Food Tom Yam": {
        "name": "Tom Yam Makanan Laut",
        "description": "Sup tom yam dengan udang, cumi, ikan, tomat, jamur"
      },
      "Creamy Chicken Mushroom Soup": {
        "name": "Sup Krim Ayam Jamur",
        "description": "Sup krim dengan irisan ayam, jamur, disajikan dengan roti bawang keju"
      },
      "Bebek Rempah": {
        "name": "Bebek Rempah",
        "description": "Bebek goreng renyah disajikan dengan urab sayur, nasi putih, dan sambal matah"
      },
      "Crispy Chicken Sambel Matah": {
        "name": "Ayam Krispi Sambel Matah",
        "description": "Dada ayam berlapis tepung goreng renyah disajikan dengan urab sayur, nasi putih, dan sambal matah"
      },
      "Ayam Bakar Plecing": {
        "name": "Ayam Bakar Plecing",
        "description": "Paha ayam panggang dengan sambal merah tradisional, disajikan dengan urab sayur dan nasi putih"
      },
      "Soto Ayam": {
        "name": "Soto Ayam",
        "description": "Sup ayam kuning dengan soun, kubis, tauge, tomat, suwiran ayam, telur, disajikan dengan nasi putih"
      },
      "Ayam Kalio": {
        "name": "Ayam Kalio",
        "description": "Paha ayam rebus lambat dengan saus kalio dan santan, disajikan dengan kacang panjang kalasan, nasi putih"
      },
      "Beef Rendang": {
        "name": "Rendang Sapi",
        "description": "Rebusan daging sapi dengan saus rendang khas Sumatera Barat, disajikan dengan kacang panjang kalasan, nasi putih"
      },
      "Ulam Segara": {
        "name": "Ulam Segara",
        "description": "Campuran makanan laut dipadukan masakan Bali: ikan bungkus daun pisang, udang dan cumi panggang saus merah, sate lilit ikan, ikan goreng, disajikan dengan nasi putih, urab sayur, sambal matah"
      },
      "Bali Tulen": {
        "name": "Bali Tulen",
        "description": "Kombinasi hidangan babi khas Bali dengan saus otentik, urab sayur, sate babi, sosis Bali, perut babi suwir, tahu manis renyah, kuah komoh, disajikan dengan nasi putih dan sambal matah"
      },
      "Segara Gunung For 2 Person": {
        "name": "Segara Gunung Untuk 2 Orang",
        "description": "Perpaduan masakan laut (segara) dengan hasil pegunungan (gunung). Ikan bungkus daun pisang, udang panggang, sambal matah ikan, ayam kukus bungkus daun pisang, bebek krispi, sate ayam & sapi, kacang panjang kalasan, urab sayur, saus merah Bali dan sambal matah, disajikan dengan nasi putih"
      },
      "Avocado Chicken Teriyaki": {
        "name": "Ayam Teriyaki Alpukat",
        "description": "Irisan dada ayam panggang dengan saus teriyaki disajikan dengan nasi putih, irisan alpukat, irisan mentimun"
      },
      "Pad Thai Prawn": {
        "name": "Pad Thai Udang",
        "description": "Mi khas Thailand terpopuler dengan udang, tahu, dan saus asam jawa (tamarind)"
      },
      "Chinese Fried Rice": {
        "name": "Nasi Goreng Oriental",
        "description": "Nasi goreng gaya oriental dengan ayam, sayuran, ayam krispi goreng, telur mata sapi, sambal dabu-dabu, dan kerupuk"
      },
      "Pork Char Siu": {
        "name": "Babi Char Siu",
        "description": "Irisan daging babi panggang wajan dengan saus hoisin Tiongkok, disajikan dengan nasi hainan, tumis pok coy dan jamur"
      },
      "Chicken Curry": {
        "name": "Kari Ayam",
        "description": "Kari kuning ayam tradisional gaya India, kacang polong, kembang kol, disajikan dengan roti prata paratha dan nasi putih"
      },
      "Aussie Tenderloin Beef": {
        "name": "Tenderloin Sapi Aussie",
        "description": "Tenderloin sapi panggang dengan sayuran mentega, kentang tumbuk keju/kentang goreng, disajikan dengan saus lada hitam/saus barbekyu/saus jamur"
      },
      "Sirloin Beef": {
        "name": "Sirloin Sapi",
        "description": "Sirloin sapi panggang dengan sayuran mentega, kentang tumbuk keju/kentang goreng, disajikan dengan saus lada hitam/saus barbekyu/saus jamur"
      },
      "Pork Ribs": {
        "name": "Iga Babi",
        "description": "Iga babi dengan saus barbekyu disajikan dengan buncis bumbu, kentang tumbuk, dan daun bawang"
      },
      "Grill Salmon": {
        "name": "Salmon Panggang",
        "description": "Loin salmon panggang dengan sayuran mentega, kentang tumbuk keju disajikan dengan saus dill mayo"
      },
      "Pan-Seared Tuna Loin": {
        "name": "Tuna Loin Panggang",
        "description": "Loin tuna panggang wajan dengan asparagus, tomat ceri, tumis jamur, kentang tumbuk keju disajikan dengan saus krim bawang putih"
      },
      "Aglio E Olio": {
        "name": "Aglio E Olio",
        "description": "Tumis dengan minyak zaitun, potongan bawang putih, kemangi kering, udang, peterseli"
      },
      "Carbonara": {
        "name": "Carbonara",
        "description": "Saus krim dengan daging sapi / daging babi, kemangi, peterseli"
      },
      "Bolognese": {
        "name": "Bolognese",
        "description": "Daging sapi cincang, sayuran dengan saus tomat disajikan bersama keju parmesan"
      },
      "Vegan Aglio E Olio": {
        "name": "Aglio E Olio Vegan",
        "description": "Tumis dengan minyak zaitun, jamur kancing ekstra, bawang bombay karamel, paprika merah, kemangi kering"
      },
      "Margarita": {
        "name": "Pizza Margarita",
        "description": "Saus tomat, kemangi, keju mozzarella ekstra"
      },
      "Hawaiian": {
        "name": "Pizza Hawaiian",
        "description": "Daging ayam / ham babi, nanas, mozzarella"
      },
      "Vegetariana": {
        "name": "Pizza Vegetarian",
        "description": "Saus tomat, zaitun hitam, bawang bombay, paprika campuran, jamur, keju"
      },
      "Peperoni": {
        "name": "Pizza Peperoni",
        "description": "Irisan sosis babi, saus tomat, zaitun hitam, paprika hijau, keju"
      },
      "Banana Split": {
        "name": "Banana Split",
        "description": "Irisan pisang manis segar, disajikan dengan tiga rasa es krim"
      },
      "Fried Banana": {
        "name": "Pisang Goreng",
        "description": "Pisang goreng bergaya Bali disajikan dengan parutan keju, meses, es krim vanila"
      },
      "Dadarl Gulung": {
        "name": "Dadar Gulung",
        "description": "Pancake pandan manis tradisional Bali yang diisi dengan parutan kelapa, disajikan dengan satu skup es krim, dan sirup buah naga"
      },
      "Ice Cream 2 Scoop": {
        "name": "Es Krim 2 Skup",
        "description": "Pilihan es krim dua skup: vanila, cokelat, stroberi"
      },
      "Blood of Patal": {
        "name": "Darah Patal",
        "description": "Wortel, jeruk, jahe hangat, dan kunyit"
      },
      "Green Clean": {
        "name": "Pembersih Hijau",
        "description": "Apel hijau Malang, nanas, paprika, bayam, adas, dan air kelapa"
      },
      "Coconuts Funch": {
        "name": "Pukulan Kelapa",
        "description": "Buah kelengkeng, persik, leci, perasan jeruk nipis, air kelapa"
      },
      "Sidemen Detox": {
        "name": "Detoks Sidemen",
        "description": "Mentimun hijau, stroberi, nanas tropis, paprika, dan daun mint"
      },
      "Peach Vibes": {
        "name": "Vibe Persik",
        "description": "Sirup persik, buah persik, madu, grenadine"
      },
      "Strawberry On Filed": {
        "name": "Stroberi di Ladang",
        "description": "Stroberi segar, daun mint, serai, sirup rosella rumahan, air soda"
      },
      "Passionate Lychee": {
        "name": "Leci Penuh Gairah",
        "description": "Jus jeruk, sirup markisa, buah leci, dan reduksi leci"
      },
      "Sparkling Mint Lemonade": {
        "name": "Lemonade Mint Bersoda",
        "description": "Jeruk nipis segar, daun mint, sirup gula, dituang dengan air soda"
      },
      "Strawberry Lychee Soda": {
        "name": "Soda Stroberi Leci",
        "description": "Sirup stroberi, irisan leci segar, perasan jeruk nipis segar, dan air soda"
      },
      "Peach Sangria": {
        "name": "Sangria Persik",
        "description": "Sirup persik, jus nanas, perasan jeruk nipis, dituang dengan air soda"
      },
      "The Rainbow": {
        "name": "Pelangi",
        "description": "Stroberi, susu segar, matcha, dengan busa susu"
      },
      "Co Range": {
        "name": "Co Range",
        "description": "Espresso, jus jeruk, sirup gula, dituang dengan air tonik"
      },
      "Caffein Fulled": {
        "name": "Penuh Kafein",
        "description": "Pisang, espresso, susu, sirup gula"
      },
      "Ultra Violet": {
        "name": "Ultra Violet",
        "description": "Leci, jus lemon, buah naga, dituang dengan air tonik"
      },
      "Lemonade Frozen": {
        "name": "Lemonade Beku",
        "description": "Rum Bacardi, triple sec, daun mint, sirup gula, perasan jeruk nipis"
      },
      "Dedari": {
        "name": "Dedari",
        "description": "Spirtus aren (arak), serai, leci, sirup rempah rumahan, rosella dituang dengan soda"
      },
      "Taksu": {
        "name": "Taksu",
        "description": "Sirup serai, infus rosella, sirup pedas, vodka, cointreau, arak, air soda"
      },
      "Vodka Lemongrass": {
        "name": "Vodka Serai",
        "description": "Vodka, gula, serai, jeruk nipis"
      },
      "Patal Sunrise": {
        "name": "Matahari Terbit Patal",
        "description": "Vodka, jus jeruk, perasan jeruk nipis, grenadine, sirup gula"
      },
      "Margarita Cocktail": {
        "name": "Margarita",
        "description": "Tequila, triple sec, asam manis, dengan pilihan rasa: Stroberi, Mangga, atau Beku (Frozen)"
      },
      "Mojito": {
        "name": "Mojito",
        "description": "Rum ringan, perasan jeruk nipis, daun mint, gula, air soda, dengan pilihan rasa: Markisa, Leci, Persik, atau Stroberi"
      },
      "Cosmopolitan": {
        "name": "Cosmopolitan",
        "description": "Vodka, cointreau, campuran asam, dan jus kranberi"
      },
      "Lychee-Rose Martini": {
        "name": "Martini Leci-Mawar",
        "description": "Gin, reduksi rosella, leci, dan vermouth manis"
      },
      "Pina Collada": {
        "name": "Pina Colada",
        "description": "Rum ringan, rum kelapa, jus nanas, dan santan kelapa"
      },
      "Jhon Collins": {
        "name": "John Collins",
        "description": "Johnnie Walker Red, perasan jeruk nipis segar, dituang air soda"
      },
      "Whiskey Sour": {
        "name": "Whiskey Sour",
        "description": "Bourbon Jim Beam, sirup gula, dan perasan jeruk nipis segar"
      },
      "Mai Tai": {
        "name": "Mai Tai",
        "description": "Rum Bacardi, amaretto disaronno, jus jeruk, jus nanas, dituang dengan rum Myers"
      },
      "Peartini": {
        "name": "Peartini",
        "description": "Vodka, cointreau, sirup persik, dan perasan jeruk nipis segar"
      },
      "Patal Blue Butterfly": {
        "name": "Kupu-Kupu Biru Patal",
        "description": "Infus bunga telang, rum Bacardi, blue curacao, triple sec, rum Myers, perasan lemon, dan soda"
      },
      "Patal Collada": {
        "name": "Patal Colada",
        "description": "Jus nanas, jus mangga, santan kelapa, sirup gula, cointreau, rum Myers"
      },
      "Bitter Sweet Sour": {
        "name": "Pahit Manis Asam",
        "description": "Minuman kopi (coffee liqueur), sirup gula, vodka, cointreau, pahit angostura, dan air tonik"
      },
      "Camories": {
        "name": "Camories",
        "description": "Campari, perasan lemon, perasan jeruk nipis, vodka, cointreau, dan air soda"
      },
      "Cream De Cacuo": {
        "name": "Cream De Cacuo",
        "description": "Minuman krim (cream liqueur), minuman kopi, sirup gula, santan kelapa, pahit angostura, dan air soda"
      },
      "Singapore Sling": {
        "name": "Singapore Sling",
        "description": "Gin Gordon, brandy ceri, benedictine, minuman pahit, perasan jeruk nipis, jus nanas, percikan air soda"
      },
      "Honey Mountain": {
        "name": "Gunung Madu",
        "description": "Rum Bacardi, triple sec, daun mint, sirup gula, perasan jeruk nipis"
      },
      "Aurora In The Sky": {
        "name": "Aurora di Langit",
        "description": "Stroberi, vodka, blue curacao, jus lemon, dituang air tonik"
      },
      "Orange Flush": {
        "name": "Rona Jeruk",
        "description": "Rum, triple sec, sirup persik, dituang air tonik"
      },
      "Red Heart": {
        "name": "Hati Merah",
        "description": "Campari, brandy ceri, perasan jeruk nipis, tequila, dituang air tonik"
      },
      "Hot Spicy": {
        "name": "Panas Pedas",
        "description": "Tequila, rum, sirup pedas, jahe, arak, perasan jeruk nipis, dituang air tonik"
      }
    }
  }
}